<template>
  <div class="plr-text-hint-widget backdrop-dark zoom-in">
    <div class="hint-container scrollable">
      <div class="hint-toolbar">
        <button
          :disabled="!(textHint?.duration && !isPaused)"
          @click="isPaused = true"
          class="btn-pause"
        />
        <button class="ctrl-c" @click="handleCopyClick" />
        <button class="btn-close" @click="handleCloseClick" />
      </div>
      <div class="plr-white-pane">
        <h4 v-if="textHint?.title" :dir="getTextDirection(textHint.title)">
          {{ textHint?.title }}
        </h4>
        <div class="pan-area">
          <p>
            <a
              v-if="isUrl(textHint.text)"
              :href="textHint.text"
              target="_blank"
              >{{ textHint.text }}</a
            >
            <template v-else>{{ textHint.text }}</template>
          </p>
        </div>
        <div v-if="false" class="plr-sub-note">
          This data generated by AI and can not be truested. Please, trust your
          brain and verified sources.
        </div>
      </div>
      <ProgressBar
        :style="{
          visibility: textHint?.duration && !isPaused ? 'visible' : 'hidden'
        }"
        :duration="textHint.duration"
        :is-paused="isPaused"
        @end="handleProgressEnd"
        height="4"
        color="#FF681D"
        backgroundColor="#FFFFFF99"
      />
    </div>
  </div>
</template>
<script lang="ts">
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
/* eslint-disable */
// @ts-ignore
import {copyText} from 'vue3-clipboard'
/* eslint-enable */
import { showToastError, showToastSuccess } from "@/helpers/notification";
import { i18n } from "@/lang";
import {
  RequestedAction,
  TextHintDto
} from "@moderrotech/servers-communication-library/src/types";
import _ from "lodash";
import ProgressBar from "@/components/ProgressBar.vue";
import { getTextDirection } from "@/helpers/string";

export default {
  components: { ProgressBar },
  setup() {
    const store = useStore();

    const textHint = computed(
      (): TextHintDto | null => store.state.session.textHint
    );

    const isUrl = (str: string) => {
      let url;
      try {
        url = new URL(str);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    };

    const handleCopyClick = () =>
      copyText(textHint.value?.text, undefined, (error: any, event: any) =>
        error
          ? showToastError(i18n.global.t("call.error.textCopy"))
          : showToastSuccess(i18n.global.t("call.success.textCopy"))
      );

    const requestedRemoteActions = computed(
      (): { action: RequestedAction; payload?: any }[] | null =>
        store.state.session.requestedActions
    );

    const isPaused = ref(false);

    watch(
      () =>
        !!_.find(
          requestedRemoteActions.value,
          v => v.action === RequestedAction.pauseTextHint
        ),
      v => {
        if (v) {
          isPaused.value = true;
          store.commit(
            "session/UNSET_REQUESTED_ACTION",
            RequestedAction.pauseTextHint
          );
        }
      }
    );

    return {
      isUrl,
      textHint,
      handleCopyClick,
      isPaused,
      handleProgressEnd: () => store.commit("session/UNSET_TEXT_HINT"),
      handleCloseClick: () => store.commit("session/UNSET_TEXT_HINT"),
      getTextDirection
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/text-hint.scss";
@import "../assets/styles/kiosk-landscape-30inch/text-hint.scss";
@import "../assets/styles/kiosk-portrait-30inch/text-hint.scss";
</style>
